import { AgentToolCallRequest, api } from "@/api";
import { action, makeAutoObservable } from "mobx";

export class ToolStore {
  constructor() {
    makeAutoObservable(this);
  }

  @action async callTool(
    threadId: string,
    toolType: string,
    data: {
      init_args?: Record<string, unknown>;
      call_args?: Record<string, unknown>;
      num_results?: number;
    }
  ) {
    const res = await api.threads.callTool(
      threadId,
      toolType,
      data as AgentToolCallRequest
    );
    return res.data as {
      task_id_list: string[];
    };
  }

  /**
   * 为镜头生成图片
   */
  @action async callGenerateImageForShotTool(
    threadId: string,
    options: {
      count: number;
      modelName: string;
      prompt: string;
      attachmentUrls: string[];
      shotIndex: number;
    }
  ) {
    return await this.callTool(threadId, "generate_image_for_shot_by_index", {
      init_args: {
        i2i_model_name: options.modelName,
        t2i_model_name: options.modelName,
        user_prompt: options.prompt,
        user_specified_images: options.attachmentUrls,
      },
      call_args: {
        shot_index: options.shotIndex,
      },
      num_results: options.count,
    });
  }

  /**
   * 生成参考图片
   */
  @action async callReferenceImageTool(
    threadId: string,
    options: {
      count: number;
      modelName: string;
      prompt: string;
      attachmentUrls: string[];
      index: number;
    }
  ) {
    return await this.callTool(threadId, "generate_reference_image_by_index", {
      init_args: {
        i2i_model_name: options.modelName,
        t2i_model_name: options.modelName,
        user_prompt: options.prompt,
        user_specified_images: options.attachmentUrls,
      },
      call_args: {
        index: options.index,
      },
      num_results: options.count,
    });
  }

  /**
   * 为镜头生成视频
   */
  @action async callGenerateVideoForShotTool(
    threadId: string,
    options: {
      count: number;
      modelName: string;
      prompt: string;
      dialogue: string;
      attachmentUrls: string[];
      shotIndex: number;
      voiceId: string;
      voicePath?: string;
      generate_type: "normal" | "avatar";
      avatar_audio_type?: string;
    }
  ) {
    return await this.callTool(threadId, "generate_video_for_shot_by_index", {
      init_args: {
        t2v_model_name: options.modelName,
        i2v_model_name: options.modelName,
        is2v_model_name: options.modelName,
        user_prompt: options.prompt,
        line_content: options.dialogue,
        user_specified_images: options.attachmentUrls,
        avatar_voice_id: options.voiceId,
        avatar_voice_path: options.voicePath,
        generate_type: options.generate_type,
        avatar_audio_type: options.avatar_audio_type,
      },
      call_args: {
        shot_index: options.shotIndex,
      },
      num_results: options.count,
    });
  }
}

export const toolStore = new ToolStore();
